"use strict";

var app = angular.module('app');

// Service for checkout the shopping cart to paypal or other sites.
app.factory('orderService', ['$http', '$q', function ($http, $q) {


    var prepareOrderData = function(ctx){

        return {
            "buyer_type":ctx.clientInformation.buyer_type,
            "company_name":ctx.clientInformation.company_name,
            "company_address":ctx.clientInformation.company_address,
            "vat_number":ctx.clientInformation.vat_number,
            "phone":ctx.clientInformation.phone,
            "cart":JSON.stringify(ctx.cartItems),
            "email":ctx.clientInformation.email,
            "name":ctx.clientInformation.name,
            "surname":ctx.clientInformation.surname,
            "invoice":ctx.clientInformation.invoice,
            "country":ctx.clientInformation.country,
            "city":ctx.clientInformation.city,
            "address":ctx.clientInformation.address,
            "zip":ctx.clientInformation.zip,
            "lang":ctx.clientInformation.lang,
            "tax":ctx.clientInformation.tax,
            "total_with_tax":ctx.clientInformation.total_with_tax.toFixed(2),
            "total_no_tax":ctx.clientInformation.total_no_tax.toFixed(2),
            "shipping_cost":ctx.clientInformation.shipping_cost.toFixed(2),
            "shipping_group":ctx.clientInformation.shipping_group,
            "total":ctx.clientInformation.total.toFixed(2),
            "tax_value": ctx.clientInformation.tax_value.toFixed(2)
        }
    };

    var storeOrderPending = function (url, data, callback, fallback) {
        $http.post(url, data).then(callback, fallback);
    };

    return {
        storeOrderPending: storeOrderPending,
        prepareOrderData:prepareOrderData
    }
}]);
